<div class="mat-modal-dialog boundryAudit-modal">
    <h2 mat-dialog-title>
        <mat-icon style="color:red; float: right; cursor: pointer; position: relative; top: 10px;"
            (click)="this.dialogRef.close()">close</mat-icon>
    </h2>
    <mat-dialog-content style="position: relative; top: -25px;">
        <span class="material-icons-outlined"
            style="color: #FF0000; font-size: 19px; position: relative; top: 5px; margin-right: 10px;">
            info</span> <span style="color: #FF455B; font-size: 14px; font-weight: 500; font-family: poppins;">Site
            boundry audit.</span>
    </mat-dialog-content>

    <mat-dialog-content style="position: relative; bottom: 15px;">
        <div class="row">
            <div class="col-sm-12">
                <table class="boundryAudit-table">
                    <thead style="border-bottom: 1px solid #EFF2F7 !important; background: #ffffff !important;">
                        <th>
                            Site
                        </th>
                        <th>
                            Updated By
                        </th>
                        <th>
                            Updated Date Time
                        </th>
                        <th>
                            Status
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of _mData">
                            <td>
                                {{item.site.siteName}}
                            </td>
                            <td>
                                {{item.updatedBy.userInfoDetails.firstName}}
                            </td>
                            <td>
                                {{item.updateOn}}
                            </td>
                            <td>
                                {{item.status}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </mat-dialog-content>
</div>